// Credits API — Cloudflare Workers API (same backend as mobile app)
// Handles: credit balance queries
import { apiClient } from '../client.js';

export const creditsApi = {
  /**
   * Get user's credit balance.
   * Calculated from credits_ledger (grant, reserve, consume, refund entries).
   * @returns {Promise<{ balance: number }>}
   */
  async getBalance() {
    return apiClient.get('/credits/balance');
  },
};
